function normalizePath(value: string): string {
  const path = value.split('?')[0].split('#')[0];
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function isNavLinkActive(href: string, currentPath: string): boolean {
  if (!href.startsWith('/') || href.startsWith('//')) {
    return false;
  }

  const link = normalizePath(href);
  const path = normalizePath(currentPath);

  if (link === '/') {
    return path === '/';
  }

  return path === link || path.startsWith(`${link}/`);
}
